import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export function profileInitial(name) {
    return name?.trim().charAt(0).toLocaleUpperCase() || 'U';
}
/**
 * Shared profile-avatar content for every Veltica surface. The parent controls
 * the avatar's size and shape; this component keeps photo failure and the
 * one-letter fallback consistent everywhere.
 */
export function ProfileAvatarContent({ name, src, imageAlt = '', }) {
    const [imageFailed, setImageFailed] = useState(false);
    useEffect(() => {
        setImageFailed(false);
    }, [src]);
    if (src && !imageFailed) {
        return (_jsx("img", { src: src, alt: imageAlt, referrerPolicy: "no-referrer", onError: () => setImageFailed(true) }));
    }
    return _jsx(_Fragment, { children: profileInitial(name) });
}
//# sourceMappingURL=ProfileAvatarContent.js.map